"use strict";

var _objectSpread = require("/home/circleci/project/web-front/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/objectSpread");
var _objectWithoutProperties = require("/home/circleci/project/web-front/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/objectWithoutProperties");
var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ListElement = void 0;
var _react = _interopRequireDefault(require("react"));
var _cn = require("@udecode/cn");
var _plateCommon = require("@udecode/plate-common");
var _classVarianceAuthority = require("class-variance-authority");
var _jsxRuntime = require("react/jsx-runtime");
var listVariants = (0, _classVarianceAuthority.cva)('m-0 ps-6', {
  variants: {
    variant: {
      ol: 'list-decimal',
      ul: 'list-disc [&_ul]:list-[circle] [&_ul_ul]:list-[square]'
    }
  }
});
var ListElementVariants = (0, _cn.withVariants)(_plateCommon.PlateElement, listVariants, ['variant']);
var ListElement = exports.ListElement = (0, _cn.withRef)(function (_ref, ref) {
  var children = _ref.children,
    _ref$variant = _ref.variant,
    variant = _ref$variant === void 0 ? 'ul' : _ref$variant,
    props = _objectWithoutProperties(_ref, ["children", "variant"]);
  var Component = variant;
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(ListElementVariants, _objectSpread({
    asChild: true,
    ref: ref,
    variant: variant
  }, props, {
    children: /*#__PURE__*/(0, _jsxRuntime.jsx)(Component, {
      children: children
    })
  }));
});